/* ============================================================
   Willy Be Smart — Theme JS v2 (quick-add gestito da willy-cart-autoopen)
   ============================================================ */
(function () {
  'use strict';

  var t = window.willyTheme || {};

  function formatMoney(cents) {
    var fmt = (t.moneyFormat || '€{{amount}}');
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  var cartDrawer = document.querySelector('[data-willy-drawer="cart"]');
  function openCart() { window.location.assign(t.cartUrl || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'); }
  function closeCart() { if (cartDrawer) { cartDrawer.classList.remove('is-open'); document.body.style.overflow = ''; } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-willy-cart-open]') && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey && !e.button) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-willy-cart-close]') || e.target.matches('.willy-drawer__overlay')) { closeCart(); }
  });

  var menuDrawer = document.querySelector('[data-willy-drawer="menu"]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-willy-menu-open]')) { menuDrawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-willy-menu-close]')) { menuDrawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  var searchOverlay = document.querySelector('[data-willy-search]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-willy-search-open]')) {
      e.preventDefault();
      searchOverlay.classList.add('is-open');
      var input = searchOverlay.querySelector('input[name="q"]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
    if (e.target.closest('[data-willy-search-close]') || e.target === searchOverlay) {
      searchOverlay.classList.remove('is-open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (cartDrawer) cartDrawer.classList.remove('is-open');
      if (menuDrawer) menuDrawer.classList.remove('is-open');
      if (searchOverlay) searchOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrapper = (minus || plus).closest('.willy-qty');
    var input = wrapper.querySelector('input');
    // Rispetta min/step dell'input (B2B: step = MOQ → solo multipli). B2C: min=1 step=1 = invariato.
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var val = parseInt(input.value, 10) || min;
    if (minus) val = Math.max(min, val - step);
    if (plus) val = val + step;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var idx = thumb.getAttribute('data-gallery-thumb');
    var gallery = thumb.closest('.willy-gallery');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) { el.classList.remove('is-active'); });
    gallery.querySelectorAll('[data-gallery-slide]').forEach(function (el) { el.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    var slide = gallery.querySelector('[data-gallery-slide="' + idx + '"]');
    if (slide) slide.classList.add('is-active');
    var counter = gallery.querySelector('[data-gallery-counter]');
    if (counter) counter.textContent = (parseInt(idx, 10) + 1) + '/' + gallery.querySelectorAll('[data-gallery-slide]').length;
  });

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-gallery-prev]');
    var next = e.target.closest('[data-gallery-next]');
    if (!prev && !next) return;
    var gallery = (prev || next).closest('.willy-gallery');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var current = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
    var nextIdx = prev ? (current - 1 + slides.length) % slides.length : (current + 1) % slides.length;
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    thumbs.forEach(function (s) { s.classList.remove('is-active'); });
    slides[nextIdx].classList.add('is-active');
    if (thumbs[nextIdx]) thumbs[nextIdx].classList.add('is-active');
    var counter = gallery.querySelector('[data-gallery-counter]');
    if (counter) counter.textContent = (nextIdx + 1) + '/' + slides.length;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-nav]');
    if (!btn) return;
    var dir = btn.getAttribute('data-carousel-nav');
    var track = btn.closest('section').querySelector('[data-carousel-track]');
    if (!track) return;
    var step = track.clientWidth * 0.7;
    track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
  });

  // ---------- Add to cart (PDP form) - delegato a willy-cart-autoopen ----------
  // NB: willy-cart-autoopen.liquid intercept fetch + form submit /cart/add.
  // Qui NON registriamo handler per data-willy-add-form per evitare doppio.

  // ---------- Quick-add ----------
  // RIMOSSO: gestito da willy-cart-autoopen.liquid (silent add + toast)
  // L'old comportamento faceva window.location.href='/cart?added='+id che e' il bug.

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartCount(cart);
        renderShippingBar(cart);
        return cart;
      });
  }

  function renderCartCount(cart) {
    document.querySelectorAll('[data-willy-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  function renderShippingBar(cart) {
    var bars = document.querySelectorAll('[data-willy-shipping-bar]');
    var threshold = t.freeShippingThreshold || 2500;
    var remain = Math.max(0, threshold - cart.total_price);
    bars.forEach(function (bar) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      var fillEl = bar.querySelector('[data-willy-shipping-pct]');
      if (fillEl) fillEl.style.width = pct + '%';
      var msg = bar.querySelector('[data-willy-shipping-msg]');
      if (msg) {
        if (remain <= 0) {
          msg.innerHTML = '<strong>Hai sbloccato la spedizione gratuita in Italia!</strong>';
        } else {
          msg.innerHTML = 'Aggiungi <strong>' + formatMoney(remain) + '</strong> per la spedizione gratuita in Italia';
        }
      }
    });
  }

  var cartChangePending = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    if (cartChangePending) return;
    cartChangePending = true;
    if (cartDrawer) cartDrawer.setAttribute('aria-busy', 'true');
    var key = btn.getAttribute('data-cart-change');
    var qty = parseInt(btn.getAttribute('data-cart-qty'), 10);
    fetch(t.cartChangeUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('Impossibile aggiornare il carrello. Riprova.');
      return r.json();
    })
      .then(function (cart) {
        renderCartCount(cart);
        renderShippingBar(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
        // Trigger refresh drawer
        window.dispatchEvent(new CustomEvent('willy:cart:updated', { detail: cart }));
      }).catch(function (error) {
        var target = document.querySelector('[data-willy-cart-body]');
        if (target) {
          var message = target.querySelector('[data-cart-error]') || document.createElement('p');
          message.setAttribute('data-cart-error', '');
          message.setAttribute('role', 'alert');
          message.textContent = error.message;
          target.prepend(message);
        }
      }).finally(function () {
        cartChangePending = false;
        if (cartDrawer) cartDrawer.removeAttribute('aria-busy');
      });
  });

  if (cartDrawer) refreshCart();

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-filters-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var filters = document.querySelector('.willy-collection__filters');
    if (filters) {
      var open = filters.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (open) filters.querySelector('summary, input, button')?.focus();
    }
  });

  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-select]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

/* Sprint 8 — Scroll reveal + magnetic buttons */
(function () {
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -80px 0px' });

    function attachReveal() {
      document.querySelectorAll('main > section:not(.willy-hero), .willy-section, .willy-multicolumn, .willy-iwt, .willy-collapsible, .willy-blog, .willy-recommendations, .willy-promo, .willy-newsletter, .willy-tiktok, .willy-bestsellers, .willy-categories, .willy-love, .willy-related, .willy-pdp-bottom, .willy-trust-strip').forEach(function (el) {
        if (!el.classList.contains('willy-reveal')) {
          el.classList.add('willy-reveal');
        }
        observer.observe(el);
      });
    }

    if (document.readyState !== 'loading') attachReveal();
    else document.addEventListener('DOMContentLoaded', attachReveal);
  }
})();

/* Sprint 10 — Wishlist (localStorage) */
(function () {
  var KEY = 'willy_wishlist';
  function getList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveList(arr) { try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {} }
  function isInList(handle) { return getList().indexOf(handle) !== -1; }
  function toggleItem(handle) {
    var arr = getList();
    var idx = arr.indexOf(handle);
    if (idx === -1) arr.push(handle); else arr.splice(idx, 1);
    saveList(arr);
    refreshCount();
    refreshButtons();
    window.dispatchEvent(new CustomEvent('willy:wishlist:updated'));
    return arr.indexOf(handle) !== -1;
  }
  function refreshCount() {
    var arr = getList();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = arr.length;
      el.hidden = arr.length === 0;
    });
  }
  function refreshButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var on = isInList(handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('title', on ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-toggle');
    if (!handle) return;
    toggleItem(handle);
    btn.style.transform = 'scale(1.2)';
    setTimeout(function () { btn.style.transform = ''; }, 200);
  });
  function renderList() {
    var container = document.querySelector('[data-wishlist-list]');
    if (!container) return;
    var arr = getList();
    if (arr.length === 0) {
      container.innerHTML = '<p class="willy-wishlist__empty">La tua lista preferiti è vuota.<br><a href="/collections/all">Esplora lo shop</a></p>';
      return;
    }
    container.innerHTML = '<p class="willy-wishlist__count">' + arr.length + ' ' + (arr.length === 1 ? 'articolo salvato' : 'articoli salvati') + '</p>' +
      '<div class="willy-wishlist__grid">' + arr.map(function (h) {
        return '<a href="/products/' + h + '" class="willy-wishlist__chip"><span>' + h.replace(/-/g, ' ') + '</span><button type="button" data-wishlist-toggle="' + h + '" aria-label="Rimuovi">&times;</button></a>';
      }).join('') + '</div>';
  }
  if (document.readyState !== 'loading') { refreshCount(); refreshButtons(); renderList(); }
  else document.addEventListener('DOMContentLoaded', function () { refreshCount(); refreshButtons(); renderList(); });
})();

/* Sprint 11 — Slideshow controls */
(function () {
  document.querySelectorAll('.willy-slideshow').forEach(function (slideshow) {
    var slides = slideshow.querySelectorAll('.willy-slideshow__slide');
    var dots   = slideshow.querySelectorAll('[data-slideshow-go]');
    var prevBtn = slideshow.querySelector('[data-slideshow-prev]');
    var nextBtn = slideshow.querySelector('[data-slideshow-next]');
    if (slides.length <= 1) return;
    var idx = 0;
    var timer = null;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n)   { d.classList.toggle('is-active', n === idx); });
    }
    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }
    function startAuto() { stopAuto(); timer = setInterval(next, 5000); }
    function stopAuto() { if (timer) clearInterval(timer); timer = null; }
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAuto(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(+d.getAttribute('data-slideshow-go')); startAuto(); });
    });
    slideshow.addEventListener('pointerenter', stopAuto);
    slideshow.addEventListener('pointerleave', startAuto);
    startAuto();
  });
})();

/* Login/Register: sposta blocco social sotto il form Willy */
(function() {
  function moveSocialUnderForm() {
    var formWrap = document.querySelector('.willy-auth__form-wrap');
    if (!formWrap) return;
    // Cerca la sezione apps che contiene il blocco social login
    var appsSection = document.querySelector('#shopify-section-template--' + document.body.dataset.templateName + '-1778831586bfd6c2a7') ||
                      document.querySelector('[id^="shopify-section-"][id*="apps"]') ||
                      document.querySelector('.section--apps') ||
                      document.querySelector('.shopify-section[id*="apps"]');
    if (!appsSection) {
      // Prova a trovare per contenuto: cerca blocco hiko/social
      var hikoBlock = document.querySelector('[id*="hiko"], [class*="hiko"], [class*="social-login"]');
      if (hikoBlock) appsSection = hikoBlock.closest('.shopify-section') || hikoBlock;
    }
    if (!appsSection) return;
    // Crea il separatore
    if (!document.querySelector('.willy-auth__social-sep')) {
      var sep = document.createElement('div');
      sep.className = 'willy-auth__social-sep';
      sep.innerHTML = '<span>oppure accedi con</span>';
      sep.style.cssText = 'display:flex;align-items:center;gap:12px;margin:24px 0 18px;color:rgba(0,0,0,.5);font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;';
      sep.querySelector('span').style.cssText = 'flex:0 0 auto;padding:0 12px;background:#fff;';
      sep.insertAdjacentHTML('afterbegin', '<span style="flex:1;height:1px;background:rgba(0,0,0,.15);padding:0;"></span>');
      sep.insertAdjacentHTML('beforeend', '<span style="flex:1;height:1px;background:rgba(0,0,0,.15);padding:0;"></span>');
      formWrap.appendChild(sep);
    }
    // Sposta la sezione apps dentro il form-wrap
    if (appsSection.parentNode !== formWrap) {
      formWrap.appendChild(appsSection);
    }
    appsSection.style.cssText = 'max-width:100%;margin:0;padding:0;';
  }
  if (document.readyState !== 'loading') moveSocialUnderForm();
  else document.addEventListener('DOMContentLoaded', moveSocialUnderForm);
})();

(function () {
  'use strict';
  var drawers = Array.from(document.querySelectorAll('[data-willy-drawer]'));
  var previousFocus = new WeakMap();
  var activeStates = new WeakMap();
  function focusable(drawer) {
    return Array.from(drawer.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0;
    });
  }
  function sync(drawer) {
    var open = drawer.classList.contains('is-open');
    if (activeStates.get(drawer) === open) return;
    activeStates.set(drawer, open);
    drawer.inert = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    var name = drawer.getAttribute('data-willy-drawer');
    document.querySelectorAll('[data-willy-' + name + '-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(open));
    });
    if (open) {
      previousFocus.set(drawer, document.activeElement);
      var first = focusable(drawer)[0];
      if (first && !drawer.contains(document.activeElement)) first.focus({preventScroll:true});
    } else {
      var trigger = previousFocus.get(drawer);
      if (trigger && trigger.isConnected && drawer.contains(document.activeElement)) trigger.focus({preventScroll:true});
    }
  }
  drawers.forEach(function (drawer) {
    sync(drawer);
    new MutationObserver(function () { sync(drawer); }).observe(drawer, {attributes:true,attributeFilter:['class']});
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var drawer = drawers.filter(function (el) { return el.classList.contains('is-open'); }).pop();
    if (!drawer) return;
    var items = focusable(drawer);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });
})();

